import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import AccountYieldsEditForm from './AccountYieldsEditForm';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchAccountYield } from 'store/actions/account-yields/fetchAccountYields';
import { updateAccountYield } from 'store/actions/account-yields/updateAccountYields';

class AccountYieldsEditContainer extends React.Component {
    componentDidMount() {
        const {
            data,
            id,
        } = this.props;

        if (utils.isEmpty(data)) {
            this.fetchData(id);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            id,
        } = this.props;

        if (prevProps.id !== id) {
            this.fetchData();
        }
    }

    fetchData = () => {
        const {
            fetch,
            id,
        } = this.props;

        fetch({
            id: id,
        });
    }

    fetchData = () => {
        const {
            fetch,
            id,
        } = this.props;

        fetch({
            id: id,
        });
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                callback: (error) => {
                    if (error) {
                        // This location should have where we bounce the error back to the form with SubmissionError.
                        resolve();
                    }

                    resolve(history.push(`/account_yields`));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            translate,
        } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        const breadcrumbs = [
            {
                label: translate('resources.account_yields.title'),
                link: '/account_yields',
            },
            {
                label: data.id,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.account_yields.actions.edit') } />

                    <Actions>
                        <ListButton url='/account_yields' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <AccountYieldsEditForm
                            data={ data }
                            form='account_yields_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

AccountYieldsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        id,
    } = props;

    return {
        data: state.account_yields.data[id],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (values) => {
            dispatch(fetchAccountYield(values));
        },
        dispatchForm: (values) => {
            dispatch(updateAccountYield(values));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(AccountYieldsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/account-yields/edit/AccountYieldsEditContainer.js